import * as Yup from 'yup';
import { PqrReconsideration } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrReconsideration = {
    hasReconsideration: false,
    replica: '',
    pqrReplica: '',
    observations: '',
};

export const validationSchema = (idReplica: string | undefined) => {
    const validationSchema: any = {
        replica: Yup.string().when('hasReconsideration', {
            is: true,
            then: () => Yup.string().required('La replica es obligatoria'),
        }),
        pqrReplica: Yup.string().when('replica', {
            is: idReplica,
            then: () =>
                Yup.string().required('El id del PQR replicado es obligatorio'),
        }),
        observations: Yup.string().when('replica', {
            is: idReplica,
            then: () =>
                Yup.string()
                    .required('Las observaciones son obligatorias')
                    .max(
                        4294967295,
                        'Las observaciones debe tener 4294967295 caracteres alfanuméricos como máximo'
                    ),
        }),
    };
    return Yup.object(validationSchema);
};
